<div class="popup-overlay-camera modal-confirm bill-fail">
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="content-popup">
              <div class="icon-popup"><img src="assets/img/group-20.png"></div>
              <div class="des-hasimg">
                  <div class="img-popup">
                      <img src="assets/img/reading-list.png"/>
                  </div>
                  <p class="text-popup"><strong>Hoá đơn của bạn không đủ điều <br>kiện để tham gia chương trình</strong></p>
                  <div class="btn-wrapper">
                      <button type="button" class="btn btn-primary btn-block" (click)="gotoCustomerInforSuccess()">Về trang thông tin khách hàng</button>
                      <button type="button" class="btn btn-primary btn-border btn-block" (click)="goHome()">Về trang chủ</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>